import React from 'react';
import Layout from '../components/battle-map/Layout';
import Largemap from '../components/battle-map/Largemap';
import Battleinfo from '../components/battle-map/Battleinfo';
import Mobilenav from '../components/battle-map/Mobilenav';
import Leaderinfo from '../components/battle-map/Leaderinfo';
import PreLoader from '../components/battle-map/PreLoader';
import DropDownOne from '../components/battle-map/DropdownOne';
import DropDownTwo from '../components/battle-map/DropdownTwo';
import DropDownThree from '../components/battle-map/DropdownThree';
import PostData from '../data/battles.json';

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.CloseText = this.CloseText.bind(this);
    this.DragText = this.DragText.bind(this);
    this.ChangeText = this.ChangeText.bind(this);
    this.ChangeLeader = this.ChangeLeader.bind(this);
    this.AppHasLoaded = this.AppHasLoaded.bind(this);
    this.nextBattle = this.nextBattle.bind(this);
    this.prevBattle = this.prevBattle.bind(this);
    this.ChangeMobile = this.ChangeMobile.bind(this);
    this.nextLeader = this.nextLeader.bind(this);
    this.prevLeader = this.prevLeader.bind(this);

    this.state = {
      textRead: false,
      leaderRead: false,
      currentBattle: 0,
      currentLeader: 0,
      AppLoaded: false,
      infoMode: 'Battle',
      x: '798',
      y: '331',
      zoom: 1.6,
      sideBarOpen: false,
      mobileRead: false,
    };
  }

  ChangeMobile() {
    this.setState({ mobileRead: !this.state.mobileRead });
  }

  componentDidMount() {
    let ScreenWidth = window.outerWidth;
    let isMobile = false;
    if (ScreenWidth < 501) {
      isMobile = true;
    }
    this.setState({ textRead: true, leaderRead: true, isMobile: isMobile });
  }

  AppHasLoaded() {
    this.setState({ AppLoaded: true });
  }

  prevBattle() {
    let curBattle = this.state.currentBattle;
    console.log(this.state.currentBattle);
    if (curBattle > 0) {
      curBattle = curBattle - 1;
      this.setState({
        currentBattle: curBattle,
        x: this.state.isMobile ? PostData[curBattle].mx : PostData[curBattle].dx,
        y: this.state.isMobile ? PostData[curBattle].my : PostData[curBattle].dy
      });
      console.log(this.state.currentBattle);
    } else {
      curBattle = curBattle + 15;
      this.setState({
        currentBattle: curBattle,
        x: this.state.isMobile ? PostData[curBattle].mx : PostData[curBattle].dx,
        y: this.state.isMobile ? PostData[curBattle].my : PostData[curBattle].dy
      });
      console.log(this.state.currentBattle);
    }
  }

  nextBattle() {
    let curBattle = this.state.currentBattle;
    console.log(this.state.currentBattle);
    if (curBattle < 15) {
      curBattle = curBattle + 1;
      this.setState({
        currentBattle: curBattle,
        x: this.state.isMobile ? PostData[curBattle].mx : PostData[curBattle].dx,
        y: this.state.isMobile ? PostData[curBattle].my : PostData[curBattle].dy,
      });
      console.log(this.state.currentBattle);
    } else {
      curBattle = curBattle - 15;
      this.setState({
        currentBattle: curBattle,
        x: this.state.isMobile ? PostData[curBattle].mx : PostData[curBattle].dx,
        y: this.state.isMobile ? PostData[curBattle].my : PostData[curBattle].dy
      });
      console.log(this.state.currentBattle);
    }
  }

  prevLeader() {
    let curLeader = this.state.currentLeader;
    if (curLeader > 0) {
      curLeader = curLeader - 1;
      this.setState({ currentLeader: curLeader });
    } else {
      curLeader = curLeader + 7;
      this.setState({ currentLeader: curLeader });
    }
  }

  nextLeader() {
    let curLeader = this.state.currentLeader;
    if (curLeader < 7) {
      curLeader = curLeader + 1;
      this.setState({ currentLeader: curLeader });
    } else {
      curLeader = curLeader - 7;
      this.setState({ currentLeader: curLeader });
    }
  }

  ChangeText(i, x, y) {
    let ScreenWidthP = window.outerWidth;
    if (ScreenWidthP < 501) {
      this.setState({
        textRead: false,
        leaderRead: true,
        currentBattle: i,
        x: PostData[i].mx,
        y: PostData[i].my,
        zoom: 1.6,
        sideBarOpen: true,
        mobileRead: false,
      });
    } else {
      this.setState({
        mobileRead: false,
        textRead: false,
        leaderRead: true,
        currentBattle: i,
        x: PostData[i].dx,
        y: PostData[i].dy,
        zoom: 2,
        sideBarOpen: true,
        mobileRead: false,
        mobileRead: false,
      });
    }

    console.log('change text called');
  }

  ChangeLeader(k) {
    this.setState({ mobileRead: false });
    this.setState({ leaderRead: false, currentLeader: k });
    this.setState({ textRead: true });
  }

  CloseText(e) {
    let newX;
    let newY;
    let windowWidth = window.outerWidth;
    let windowHeight = window.outerHeight;
    console.log(`closing text isMobile: ${this.props.isMobile}`);

    if (!this.state.isMobile) {
      newX = this.state.x * 0.6;
      newY = this.state.y * 0.61;
      console.log(newX);
    } else {
      newX = this.state.mx;
      newY = this.state.m;
      console.log(`Im mobile close x :${this.state.mx}`);
    }

    this.setState({
      textRead: true,
      leaderRead: true,
      zoom: 1.6,
      x: newX,
      y: newY,
      sideBarOpen: false,
    });
    console.log(e);
  }

  DragText() {
    this.setState({
      textRead: true,
      leaderRead: true,
      zoom: 1.6,
      sideBarOpen: false,
      mobileRead: false,
    });
  }

  render() {
    return this.state.AppLoaded ? (
      <Layout>
        <div
          className="map-container"
          animate={this.stateAppLoaded ? { opacity: 1 } : { opacity: 0 }}
        >
          <div className="burger" onClick={this.ChangeMobile}>
            <div className="burger_line"></div>
            <div className="burger_line"></div>
            <div className="burger_line"></div>
          </div>
          <nav>
          <DropDownOne 
            onPin={this.ChangeText}
          />
          <DropDownTwo 
            onPin={this.ChangeLeader}
          />
          <DropDownThree/>
          </nav>

          <Largemap
            onDrag={this.DragText}
            onSelect={this.CloseText}
            onPin={this.ChangeText}
            currentBattle={this.state.currentBattle}
            x={this.state.x}
            y={this.state.y}
            zoom={this.state.zoom}
            isMobile={this.state.isMobile}
            sideBarOpen={this.state.sideBarOpen}
          />

          <Battleinfo
            textRead={this.state.textRead}
            onPin={this.ChangeText}
            currentBattle={this.state.currentBattle}
            onSelect={this.CloseText}
            onNext={this.nextBattle}
            onPrev={this.prevBattle}
          />

          <Leaderinfo
            leaderRead={this.state.leaderRead}
            currentLeader={this.state.currentLeader}
            onSelect={this.CloseText}
            onNext={this.nextLeader}
            onPrev={this.prevLeader}
          />
          <Mobilenav
            mobileRead={this.state.mobileRead}
            onPin={this.ChangeText}
            onLead={this.ChangeLeader}
            closeNav={this.ChangeMobile}
          />
        </div>
      </Layout>
    ) : (
        <PreLoader onComplete={this.AppHasLoaded} />
      );
  }
}

export default IndexPage;
